// extracted by mini-css-extract-plugin
export default {"wrapper":"Spinner_wrapper__X9A--","loader":"Spinner_loader__2osxn","load8":"Spinner_load8__rqKOC","spinnerText":"Spinner_spinnerText__FVSQJ"};